import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcListItem } from '@one/react';

export type PocListItemProps = ComponentPropsWithoutRef<typeof OwcListItem>;

export const PocListItem = forwardRef<ElementRef<typeof OwcListItem>, PocListItemProps>((props, ref) => (
    <OwcListItem ref={ref} {...props} />
));

PocListItem.displayName = 'PocListItem';
